class FavoritesApi {
    constructor(api, opts) {
        this.api = api;
        this.options = {
            ...opts,
        };
    }

    get() {
        return this.api.requestGet(this.api.route('favorites.index'), null, {
            withCredentials: true,
        });
    }

    store(data) {
        return this.api.requestPost(this.api.route('favorites.store'), data, {
            withCredentials: true,
        });
    }

    destroy(data) {
        const { id = null } = data || {};
        return this.api.requestDelete(this.api.route('favorites.destroy', { favorite: id }), data, {
            withCredentials: true,
        });
    }
}

export default FavoritesApi;
